import React from 'react';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import SortingIcon from '../UI/SortingIcon';

const productSystemTableHeadKabel = (props) => {

  const ct = useCustomTranslation();

  const filterCol = (col) => {
    props.onFilterTableColumnsAction(col)
  }

  return (
    <thead>
      <tr>
        <th onClick={()=>filterCol('penetrations')} scope="col" className="colLeft sortableColumnHeadline">
        <SortingIcon
          currentColumn={'penetrations'}
          sortColumn={props.sortColumn}
          sortDirection={props.sortDirection} />
          { ct('wizard.steps.product_solution.cable.table.header.penetrations.long') }</th>
        <th className={"colLeft " + props.color} colSpan={3} style={{width: "120px"}}>{ ct('wizard.steps.product_solution.cable.table.header.quantity.long') }</th>
        <th scope="col">{ ct('wizard.steps.product_solution.cable.table.header.durchm_buendel.long') }</th>
        <th scope="col">{ ct('wizard.steps.product_solution.cable.table.header.durchm_speedpipe.long') }</th>
        <th scope="col">{ ct('wizard.steps.product_solution.cable.table.header.durchm_einzelleitung.long') }</th>
        <th onClick={()=>filterCol('product_name')}  scope="col" className="colLeft sortableColumnHeadline">
        <SortingIcon
          currentColumn={'product_name'}
          sortColumn={props.sortColumn}
          sortDirection={props.sortDirection} />
        { ct('wizard.steps.product_solution.cable.table.header.produkt.long') }</th>
        <th scope="col" style={{width: "90px"}}>{ ct('wizard.steps.product_solution.cable.table.header.fwk.long') }</th>
        <th scope="col" className="colLeft" style={{width: "100px"}}>{ ct('wizard.steps.product_solution.cable.table.header.verweis.long') }</th>
      </tr>
    </thead>
  )
};


export default productSystemTableHeadKabel;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableHeadKabel.js